import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import FooterLogo from "../../assets/logos/ab1_logo.png";
import FooterLogoBlack from "../../assets/logos/ab1_logo_black.png";
import InstaLogo from "../../assets/logos/instagram-logo.png";
import InstaLogoBlack from "../../assets/logos/instagram-logo-black.png";
import XLogo from "../../assets/logos/x-logo.png";
import XLogoBlack from "../../assets/logos/x-logo-black.png";
import FacebookLogo from "../../assets/logos/facebook-logo.png";
import FacebookLogoBlack from "../../assets/logos/facebook-logo-black.png";
import NBAALogo from "../../assets/logos/NBAA.png";
import NBAALogoDark from "../../assets/logos/NBAA-b.png";
import AirLogo from "../../assets/logos/4air.png";
import AirLogoDark from "../../assets/logos/4air-b.png";
import WyvernLogo from "../../assets/logos/jira.png";
import Tuvoli from "../../assets/logos/Tuvoli.png";
import Flyeasy from "../../assets/logos/Flyeasy.png";
import FlyeasyDark from "../../assets/logos/Flyeasy-b.png";
import CarbonNeutralLogo from "../../assets/logos/carbon-neutral.png";
import JALogoDark from "../../assets/logos/operator-logo-b.png";
import JALogoWhite from "../../assets/logos/operator-logo-w.png";
import PortsideAvianis from "../../assets/logos/portside-avianis.png";
import Portside from "../../assets/logos/portside.png";
import { footerSectionLinks } from "../../constants/app-constants";
import "./Footer.scss";

const Footer = () => {
  const location = useLocation();
  const [theme, setTheme] = useState(
    location.pathname === "/" ? "light" : "dark",
  );
  useEffect(() => {
    setTheme(location.pathname === "/" ? "light" : "dark");
  }, [location.pathname]);
  return (
    <div className={`footer-main footer-theme-${theme}`}>
      <div className={`footer-root footer-root-${theme}`}>
        <footer>
          <div className="footer-sections-logo">
            <div className="footer-img">
              <img
                src={theme === "dark" ? FooterLogo : FooterLogoBlack}
                alt="AB1 logo"
                className="footer-ab1-logo"
              />
            </div>

            <div className="footer-img-partner">
              <p className="footer-section-title-partner">Partner</p>

              <img
                src={theme === "dark" ? JALogoWhite : JALogoDark}
                alt="Partner logo"
                className="footer-partner-logo"
              />
            </div>
          </div>
          <div className="footer-root-main">
            {footerSectionLinks.map(({ title, links }, index) => {
              return (
                <div key={index} className="footer-sections">
                  <p className="footer-section-title">{title}</p>
                  <ul
                    className={`footer-section-list footer-section-list-${theme}`}
                  >
                    {links.map(
                      ({ itemName, href, external = false }, indexVal) => {
                        return (
                          <li key={indexVal}>
                            {!external && <Link to={href}>{itemName}</Link>}
                            {external && <a href={href}>{itemName}</a>}
                          </li>
                        );
                      },
                    )}
                  </ul>
                </div>
              );
            })}
            <div className="footer-sections-c">
              <div className="inner-section">
                <a href="#">
                  <img src={Portside} className="footer-c-3" alt="" />
                </a>
                <a href="#">
                  <img src={PortsideAvianis} className="footer-c-3" alt="" />
                </a>
                <a href="#">
                  <img
                    src={theme === "dark" ? NBAALogo : NBAALogoDark}
                    className="footer-c-1"
                    alt=""
                  />
                </a>
                <a href="#">
                  <img
                    src={theme === "dark" ? AirLogo : AirLogoDark}
                    className="footer-c-2 footer-4air-logo"
                    alt=""
                  />
                </a>
                <a href="#">
                  <img
                    src={CarbonNeutralLogo}
                    className="footer-c-2 footer-carbon-logo"
                    alt=""
                  />
                </a>
                {/* <a href="#">
                  <img src={WyvernLogo} className="footer-c-4" alt="" />
                </a> */}
                {/* <a target="_blank" href="#">
                <img
                  src={AvinodeLogo}
                  className='footer-c-5'
                  alt=''
                />
              </a> */}
              </div>
            </div>
          </div>
          <div className="footer-sections-si">
            <div>
              <a target="_blank" href="https://www.instagram.com/airbook_one">
                <img
                  src={theme === "dark" ? InstaLogo : InstaLogoBlack}
                  className="footer-si"
                  alt="Follow us on Instagram"
                />
              </a>
              <a target="_blank" href="https://x.com/airbookone">
                <img
                  src={theme === "dark" ? XLogo : XLogoBlack}
                  className="footer-si"
                  alt="Follow us on Twitter"
                />
              </a>
              <a
                target="_blank"
                href="https://www.facebook.com/Airbookone-104373114981452"
              >
                <img
                  src={theme === "dark" ? FacebookLogo : FacebookLogoBlack}
                  className="footer-si"
                  alt="Follow us on Facebook"
                />
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
